import { Injectable } from '@angular/core';
import * as CryptoJS  from 'crypto-js';

declare let dataLayer: Array<object>; // Declare the dataLayer array

@Injectable({
  providedIn: 'root'
})
export class GtmService {
  constructor() {}

  hashString(input: string, shouldTruncate: boolean = false, length: number = 40): string {
    // Hash the string using SHA-256
    const hash = CryptoJS.SHA256(input).toString();

    if (shouldTruncate) {
      // Extract the first 40 characters for specific variables
      return hash.substr(0, length);
    } else {
      // Return the full hash for other variables
      return hash;
    }
  }

  sendEvent(event: string, data: object) {
    // Push the event and data to the dataLayer
    dataLayer.push({ event, ...data });
  }

  sendDoctorChoosenEvent(selectedDoctor,gotoURL='')
  {
    dataLayer.push({ 
      event: 'make_appointment',
      appointmentType: "Doctor's Appointment",
      buttonTitle: 'submit_step_1',
      doctor: selectedDoctor, // all value in eng, the doctor chosen
      description: "Doctor's Appointment form - select doctor",
      destinationUrl: gotoURL, // if applicable, the landing page of the content.
    });
  }
  sendSlotChosenEvent(selectedDoctor,gotoURL='')
  {
    dataLayer.push({ 
      event: 'make_appointment',
      appointmentType: "Doctor's Appointment",
      buttonTitle: 'submit_step_2',
      doctor: selectedDoctor, // all value in eng, the doctor chosen
      description: "Doctor's Appointment form - select appointment slot",
      destinationUrl: gotoURL, // if applicable, the landing page of the content.
    })
  }
  sendPayNowEvent(selectedDoctor,gotoURL='')
  {
    dataLayer.push({ 
      event: 'make_appointment',
      appointmentType: "Doctor's Appointment",
      buttonTitle: 'submit_step_3',
      doctor: selectedDoctor, // all value in eng, the doctor chosen
      method: 'Pay Now', // all value in eng, i.e. payment method selected
      description:"Doctor's Appointment form - select patient",
      destinationUrl: gotoURL, // if applicable, the landing page of the content.
    })
  }
  sendPayAtHospitalEvent(selectedDoctor,gotoURL='')
  {
    dataLayer.push({ 
      event: 'make_appointment',
      appointmentType: "Doctor's Appointment",
      buttonTitle: 'submit_step_3',
      doctor: selectedDoctor, // all value in eng, the doctor chosen
      method: 'Pay At Hospital', // all value in eng, i.e. payment method selected
      description:"Doctor's Appointment form - select patient",
      destinationUrl: gotoURL, // if applicable, the landing page of the content.
    })
  }
  sendAppointmentConfirmedEventForPayNow(selectedDoctor,gotoURL='')
  {
    dataLayer.push({ 
      event: 'make_appointment',
      appointmentType: "Doctor's Appointment",
      buttonTitle: "appointment_thank_you_page",
      doctor: selectedDoctor, // all value in eng, the doctor chosen
      method: 'Pay Now', // all value in eng, i.e. payment method selected
      description: "Doctor's Appointment form - complete successfully",
      destinationUrl: gotoURL, // if applicable, the landing page of the content.
    })
  }
  sendAppointmentConfirmedEventForPayAtHospital(selectedDoctor,gotoURL='')
  {
    dataLayer.push({ 
      event: 'make_appointment',
      appointmentType: "Doctor's Appointment",
      buttonTitle: "appointment_thank_you_page",
      doctor: selectedDoctor, // all value in eng, the doctor chosen
      method: 'Pay At Hospital', // all value in eng, i.e. payment method selected
      description: "Doctor's Appointment form - complete successfully",
      destinationUrl: gotoURL, // if applicable, the landing page of the content.
    })
  }
  sendLoginPageLandingEvent(gotoURL='')
  {
    dataLayer.push({ 
      event: 'login',
      buttonTitle: "start_login",
      method: "mobile number", // all value in eng, pass other methods if available
      description: "Login - start login",
      destinationUrl: gotoURL, // if applicable, the landing page of the content.
    })
  }
  sendOTPButtonClickEvent(gotoURL='')
  {
    dataLayer.push({ 
      event: 'login',
      buttonTitle: "send_otp",
      method: "mobile number", // all value in eng, pass other methods if available
      description: "Login - send otp button",
      destinationUrl: gotoURL, // if applicable, the landing page of the content.
    })
  }
  sendVerifyOTPButtonClickEvent(gotoURL='')
  {
    dataLayer.push({ 
      event: "login",
      buttonTitle: "verify_otp",
      method: "mobile number", // all value in eng, pass other methods if available
      description: "Login - verify otp button",
      destinationUrl: gotoURL, // if applicable, the landing page of the content.
    })
  }
  sendLoginCompleteEvent(mobile_no,gotoURL='')
  {
    let sanitizeMobile=mobile_no?mobile_no:'';
    let hashedMobile=sanitizeMobile.length>0?this.hashString(sanitizeMobile,true):'';
    dataLayer.push({ 
      event: 'login',
      buttonTitle: 'complete_login',
      method: 'mobile number', // all value in eng, pass other methods if available
      phone:hashedMobile,
      userId: hashedMobile, // user email hashed in SHA 256
      description: 'Login - complete login',
      destinationUrl: gotoURL, // if applicable, the landing page of the content.
    })
  }
  sendUserResgisterdEvent(user,gotoURL='')
  {
    let paient_name=user.title+" "+user.first_name+" "+user.last_name;
    dataLayer.push({ 
      event: 'sign_up',
      buttonTitle: 'complete_registration',
      method: 'mobile number', // all value in eng, pass other methods if available
      name: this.hashString(paient_name, true), // name hashed in SHA 256 and truncated to 40 characters
      phone: this.hashString(user.mobile, true), // phone hashed in SHA 256 and truncated to 40 characters
      email: this.hashString(user.email, true), // email hashed in SHA 256 and truncated to 40 characters
      age: user.age, // calculated the current age of user using their dob
      gender: user.gender, // gender selected by user
      userId: this.hashString(user.mobile,true), // user email hashed in SHA 256
      description: 'Registration - complete registration of main patient',
      destinationUrl: gotoURL, // if applicable, the landing page of the content.
    })
  }
  sendLabReportDownloadEvent(gotoURL = ''): Promise<void> {
    return new Promise<void>((resolve) => {
        dataLayer.push({
            event: "profile",
            buttonTitle: "download_report",
            description: "Profile - Lab Reports download button",
            destinationUrl: gotoURL,
        });
        resolve();
    });
  }
  
}
